import gql from 'graphql-tag';
import { apollo } from 'src/features';

// TODO 1. customer.number убрал
// TODO 2. customer.email убрал
const query = (userRole, isExternalOperator) => {
  const commentReqField = userRole !== 'CUSTOMER'
    ? 'comment'
    : '';
  const privateCustomerData = isExternalOperator
    ? ''
    : `
      lastName
      middleName
      gender
      birthdate
      accounts {
        id
        provider
        providerId
      }
    `;
  return gql`
    query Customer($id: ID!){
      customer(id: $id){
        ${privateCustomerData}
        ${commentReqField}
        id
        firstName
        vip
        description
        identified
        customInfo {
          label
          value
        }
      }
    }`;
};

export function parseAccount(item) {
  return {
    id: item.id,
    title: item.providerId,
    type: item.provider,
  };
}

function parse(customer) {
  const item = {
    ...customer,
    name: customer.firstName,
    type: customer.identified ? 'client' : 'anon',
  };
  return {
    id: item.id,
    name: item.name,
    type: item.type,
    omniCustomer: {
      id: item.id,
      firstName: item.firstName,
      customInfo: item.customInfo,
      lastName: item.lastName, // TODO! проверить, что базовые поля здесь нормально отрабатывают как undefined для внешнего пользователя
      middleName: item.middleName,
      gender: item.gender,
      birthdate: item.birthdate,
      vip: item.vip,
      accounts: (item.accounts && item.accounts.map((res) => parseAccount(res))) || [],
      comment: item.comment,
    },
  };
}

export default function getClientCard(customerId, userRole, isExternalOperator = false) {
  return apollo.client.query({
    query: query(userRole, isExternalOperator),
    variables: {
      id: parseInt(customerId, 10),
    },
    fetchPolicy: 'network-only',
  }).then((res) => parse(res.data.customer));
}
